var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.support),expression:"support"}],ref:"drop",staticClass:"uploader-drop",class:_vm.dropClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }